"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setTimer = void 0;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var actionSetTimer = function actionSetTimer(timer, stageId) {
  return {
    payload: _defineProperty({}, stageId, timer),
    type: 'SET_TIMER'
  };
};

var setTimer = actionSetTimer;
exports.setTimer = setTimer;